import { useCallback } from 'react'
import type { ChangeEvent } from 'react'
import Group from 'components/utils/Group'
import Switch from 'LuxKit/Switch/Switch'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'
import type { ConsentPurpose } from '../../consent/types'

interface Props {
  title: string
  description: string
  checked: boolean
  disabled?: boolean
  name?: ConsentPurpose
  onToggle?: (purpose: ConsentPurpose, checked: boolean) => void
}

function ConsentPurposeRow({
  title,
  description,
  checked,
  disabled = false,
  name,
  onToggle,
}: Props) {
  const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    if (!name || !onToggle) return
    onToggle(name, event.currentTarget.checked)
  }, [name, onToggle])

  return (
    <Group
      direction="horizontal"
      horizontalAlign="space-between"
      verticalAlign="start"
      gap={16}
    >
      <Group direction="vertical" gap={4}>
        <BodyTextBlock weight="bold" variant="medium">{title}</BodyTextBlock>
        <CaptionTextBlock variant="medium" colour="light-foreground-alt">
          {description}
        </CaptionTextBlock>
      </Group>
      <Switch
        checked={checked}
        disabled={disabled}
        name={name}
        role="switch"
        aria-label={title}
        onChange={handleChange}
      />
    </Group>
  )
}

export default ConsentPurposeRow
